// src/app/services/gsd-support.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GsdSupportRequestDto {
  subject: string;
  comment: string;
  fileBase64: File;
}

@Injectable({
  providedIn: 'root'
})
export class GsdSupportService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  sendSupportRequest(payload: FormData): Observable<any> {
    const url = this.apiUrl + 'GsdSupport/SendSupportRequest';
    return this.http.post(url, payload);
  }
}
